export default "/assets/heart-dark-gray-outline.svg";